<template>
    <div class="templateDesigner group p-20">
        <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
            <div class="design-options p-10 p-b-0 m-b-20 primarybg" v-if="!showFullService">
                <a @click="$router.go(-1)" class="btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg"><span class="icon-angle-left m-r-5 primarytext"></span> Back to Designer</a>
                <!-- <button type="button" :class="{ orange: (saveStatus !== 'Save Design') }" class="btn btn-outline-success solid m-b-10 right primaryborder m-r-5" @click="">Download Files</button> -->
                <!-- <a :href="'http://localhost:8080/?user=primo&token=qU39F6uHYvaDoR7C6Z7pe2tAr2iHTh3w&mode=designer&template='+$store.state.template.id" class="btn btn-outline-primary right m-b-10 m-r-5 primaryborder"> -->
                    <!-- RELOAD -->
                <!-- </a> -->
                <button type="button" v-if="$auth.user().vendor" class="btn btn-outline-success solid m-b-10 right animated pulse primaryborder m-r-5" @click="downloadFiles()">Download Files</button>
            </div>
            <div class="design-options p-10 p-b-0 m-b-20 primarybg" v-else>
                <h3>EDDM Route Selection</h3>
                <p class="right notice">Notice: If you leave this page before route selection is complete, you will lose your progress.</p>
            </div>
        </transition>
        <div class="row mainSection">
            <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
                <div class="col-sm-12" style="position: absolute; left: 10px; right: 10px; width: auto; z-index:10;" v-if="showFullService">
                    <EddmMap :accessToken="eddm_token" :colorspec="selected.colorspec" :date="selected.date | moment('YYYY-MM-DD')" :runsize="selected.product.detail.data[0].runsize_uuid" :product="selected.product.id" @saveEddmData="saveEddmData"></EddmMap>
                </div>
            </transition>
            <div class="col-sm-6 design-preview">
                <FilePreview ref="preview"></FilePreview>
            </div>

            <div class="col-sm-6 order-options">
                <div class="group" v-if="!downloadOnly">
                    <div class="panel-group" id="accordion-group-1">

                        <!-- File Approval -->
                        <div class="panel panel-default prod-approval panel-1 active">
                            <div class="panel-heading" @click.stop.prevent="setActivePanel('.panel-1', $event)">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion-group-1" href="#collapseOne-1" aria-expanded="true">
                                        <span>File Approval</span>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseOne-1" class="panel-collapse collapse in" aria-expanded="true" style="">
                                <!--  class="panel-collapse collapse" aria-expanded="false" style="height: 0px;" -->
                                <div class="panel-body">
                                        <FileApproval @next="nextAccordion" @preview="setPreview"></FileApproval>
                                </div>
                            </div>
                        </div>

                        <!-- Product Options -->
                        <div class="panel panel-default prod-options panel-2">
                            <div class="panel-heading" @click.stop.prevent="setActivePanel('.panel-2', $event)">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion-group-1" href="#collapseTwo-2" class="collapsed" aria-expanded="false">
                                        <span>{{ (selected.product) ? 'Product:' : 'Product Options' }}</span> {{ (selected.product) ? selected.product.description : '' }}
                                        <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                                            <span class="right" v-if="selected.product_cost !== null && !this.$store.state.template.eddm_only">${{ calculateCost('product') }}</span>
                                        </transition>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseTwo-2" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                                <div class="panel-body">
                                    <p v-if="products.length < 1" class="m-t-10">
                                        <center>
                                            <FulfillingBouncingCircleSpinner
                                                :animation-duration="2500"
                                                :size="45"
                                                :color="'#232F4B'">
                                            </FulfillingBouncingCircleSpinner>
                                        </center>
                                    </p>
                                    <ProductSelector :products="products" :selected="selected" :eddmDates="eddm_dates" @updateSelected="updateSelected" @next="nextAccordion" :button="($store.state.template.eddm_only)?'Select EDDM Routes':'Select Shipping Options'"></ProductSelector>
                                </div>
                            </div>
                        </div>

                        <!-- Shipping Options -->
                        <div class="panel panel-default prod-shipping panel-3" v-if="!this.$store.state.template.eddm_only">
                            <div class="panel-heading" @click.stop.prevent="setActivePanel('.panel-3', $event)">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion-group-1" href="#collapseThree-3" class="collapsed" aria-expanded="false">
                                        <span>{{ (selected.method) ? 'Shipping:' : 'Shipping & Turnaround' }}</span> {{ (selected.method) ? selected.method.service_name : '' }}
                                        <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                                            <span class="right" v-if="selected.method || selected.turnaround">{{ (selected.method && selected.method.group_with_cart) ? 'Calculated In Cart' : '$' + calculateCost('shipping') }}</span>
                                        </transition>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseThree-3" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                                <div class="panel-body">
                                    <ShippingSelector ref="shipping" :products="products" :selected="selected" @updateSelected="updateSelected" @next="nextAccordion" button="Continue to Summary"></ShippingSelector>
                                </div>
                            </div>
                        </div>

                        <!-- Quick Summary -->
                        <div class="panel panel-default prod-summary panel-4">
                            <div class="panel-heading" @click.stop.prevent="setActivePanel('.panel-4', $event)">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion-group-1" href="#collapseFour-4" class="collapsed" aria-expanded="false">
                                        <span>Quick Summary</span>
                                        <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                                            <span class="right" v-if="calculateCost() > 0 && !this.$store.state.template.eddm_only">Total: ${{ calculateCost() }}</span>
                                        </transition>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseFour-4" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">

                                <!-- // STANDARD SUMMARY -->
                                <div class="panel-body" v-if="!this.$store.state.template.eddm_only">
                                    <div class="group row m-b-0 ">
                                        <div class="col-sm-3">
                                            <div class="m-t-5"><h4 class="m-t-0 m-b-0">Product:</h4></div>
                                        </div>
                                        <div class="col-sm-9">
                                            <div class="m-t-5"><h4 class="m-t-0 m-b-0">{{ (selected.product) ? selected.product.description : '' }}</h4></div>
                                        </div>
                                    </div>
                                    <div class="group row m-b-0 ">
                                        <div class="col-sm-12">
                                            <hr style="width: 100%; height: 1px; background: #fdfdfd;" class="m-b-10" />
                                        </div>
                                    </div>
                                    <div class="group row m-b-0">
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Order Date: <span class="pull-right">{{ new Date() | moment("MM/DD/YYYY") }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Subtotal: <span class="pull-right">${{ calculateCost('product') }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Quantity: <span class="pull-right">{{ selected.runsizeDescription }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4><span class="shipping-type">Shipping:</span> <span class="pull-right">{{ (selected.method && selected.method.group_with_cart) ? 'Calculated In Cart' : '$' + calculateCost('shipping') }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Sets: <span class="pull-right">1</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Total: <span class="pull-right">${{ calculateCost() }}</span><br /><small>(not including tax)</small></h4>
                                        </div>
                                    </div>
                                    <div class="group row m-b-0 ">
                                        <div class="col-sm-12">
                                            <button v-if="imagesProcessing.length > 0" @click="stillProcessing()" class="btn btn-warning pull-right">Finishing up files, please wait..</button>
                                            <button v-else class="btn btn-success pull-right" @click="addToCart()">Add to Cart</button>
                                        </div>
                                    </div>
                                </div>

                                <!-- // EDDM SUMMARY -->
                                <div class="panel-body" v-else-if="eddmData !== null">
                                    <div class="group row m-b-0">
                                        <div class="col-sm-3">
                                            <div class="m-t-5"><h4 class="m-t-0 m-b-0">Full Service EDDM:</h4></div>
                                        </div>
                                        <div class="col-sm-9">
                                            <div class="m-t-5"><h4 class="m-t-0 m-b-0">{{ (selected.product) ? selected.product.description : '' }}</h4></div>
                                        </div>
                                    </div>
                                    <div class="group row m-b-0">
                                        <div class="col-sm-12">
                                            <hr style="width: 100%; height: 1px; background: #fdfdfd;" class="m-b-10" />
                                        </div>
                                    </div>
                                    <div class="group row m-b-0">
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Residential: <span class="pull-right">{{ eddmData.map_event_data.tot_res }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Routes: <span class="pull-right">{{ eddmData.map_event_data.tot_sel }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Business: <span class="pull-right">{{ eddmData.map_event_data.tot_bus }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Total: <span class="pull-right">{{ eddmData.map_event_data.tot_cnt }}</span></h4>
                                        </div>
                                    </div>
                                    <div class="group row m-b-0">
                                        <div class="col-sm-12 m-t-20">
                                            <h4>Product Information:</h4>
                                            <hr style="width: 100%; height: 1px; background: #fdfdfd;" class="m-b-10" />
                                        </div>
                                    </div>
                                    <div class="group row m-b-0 ">
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Order Date: <span class="pull-right">{{ new Date() | moment("MM/DD/YYYY") }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Product Cost: <span class="pull-right">${{ calculateCost('product') }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Delivery Date: <span class="pull-right">{{ selected.date | moment("MM/DD/YYYY") }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>EDDM Service Cost: <span class="pull-right">${{ calculateCost('eddm_service') }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Sets: <span class="pull-right">1</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Postage Cost: <span class="pull-right">${{ calculateCost('shipping') }}</span></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4></h4>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <h4>Total: <span class="pull-right">${{ calculateCost() }}</span><br /><small>(not including tax)</small></h4>
                                        </div>
                                    </div>
                                    <div class="group row m-b-0 ">
                                        <div class="col-sm-12">
                                            <button v-if="imagesProcessing.length > 0" @click="stillProcessing()" class="btn btn-warning pull-right">Finishing up files, please wait..</button>
                                            <button v-else class="btn btn-success pull-right" @click="addToCart()">{{cartButtonText}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Files Processing -->
                        <transition-group enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutRight">
                            <div class="panel panel-success m-t-5" v-if="imagesProcessing.length > 0" v-for="item in imagesProcessing" :key="item">
                                <div class="panel-heading p-l-10">
                                    <h4 class="panel-title">
                                        <span class="left m-r-10 m-t-5"><SpringSpinner :animation-duration="2000" :size="14" :color="'#3C736D'"></SpringSpinner></span>
                                        Processing {{ item }} file..
                                    </h4>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </div>

                <div class="group" v-else>
                    <div class="panel-group" id="accordion-group-2">
                        <div class="panel panel-default panel-1 active">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion-group-2" href="#collapseOne-2" aria-expanded="true" class="">
                                        Download Files
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseOne-2" class="panel-collapse collapse in" aria-expanded="true" style="">
                                <div class="panel-body">
                                    <p>
                                        This template does not yet have any products assigned to it.<br /><br />
                                        You can download the print ready files below:<br />
                                        <button type="button" class="btn btn-outline-success solid m-b-10 primaryborder animated pulse m-t-20 m-b-0" @click="downloadFiles()">Download Files</button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* global Helpers */
/* global FileFlip */

// import Eddm from '@/assets/js/core/Eddm'
import FilePreview from './partials/FilePreview.vue'
import FileApproval from './partials/FileApproval.vue'
import EddmMap from './partials/EddmMap.vue'
import ProductSelector from './partials/ProductSelector.vue'
import ShippingSelector from './partials/ShippingSelector.vue'
import { templateSaving } from '@/components/mixins/templateSaving'
import { windowMessaging } from '@/components/mixins/windowMessaging'
import { FulfillingBouncingCircleSpinner, SpringSpinner } from 'epic-spinners'
const { getCurrentVendorID } = require('./common/helpers')

export default {
    name: 'templateOptions',
    components: {FilePreview, FileApproval, ProductSelector, ShippingSelector, EddmMap, FulfillingBouncingCircleSpinner, SpringSpinner},
    mixins: [templateSaving, windowMessaging],
    data () {
        return {
            msg: 'Template Options',
            products: [],
            selected: {
                product: null,
                product_cost: null,
                runsize: null,
                runsizeDescription: null,
                colorspec: null,
                options: null,
                name: this.$store.state.savedTemplate.name,
                turnaround: null,
                shipping: null,
                blind: null,
                date: null,
                method: null
            },
            showFullService: false,
            downloadOnly: false,
            eddm_dates: [],
            eddm_token: null,
            eddmData: null,
            dm_fee: 0,
            cartButtonText: 'Add to Cart',
            imagesProcessing: [],
            watcher: null
        }
    },
    beforeMount () {
        this.watcher = this.$store.watch((state) => state.savedTemplate, (newValue, oldValue) => {
            this.checkImages()
        })

        let data = {
            template: this.$store.state.template.id
        }
        this.axios.post('/products/search?include=option_groups.options.pricing,detail', data)
        .then((res) => {
            this.products = res.data.data
        })
        .catch((err) => {
            this.downloadOnly = true
            console.log(err)
        })

        // Set Default Colorspec
        let template = this.$store.state.template
        if (template.front && template.back && template.foil_front && template.foil_back) {
            this.selected.colorspec = '34527644-b4fd-4ffb-9092-1318eefcd9d9' // 5/5
        } else if (template.front && template.back && template.foil_front) {
            this.selected.colorspec = 'e9e9dfb3-fba1-4d60-972c-fd9ca5904d33' // 5/4
        } else if (template.front && template.back && template.foil_back) {
            this.selected.colorspec = '2ba18f74-0f96-487e-8b6e-985b404b3305' // 4/5
        } else if (template.front && template.foil_front) {
            this.selected.colorspec = 'a75ac2f1-9911-48d6-841d-245b5ac08f27' // 5/0
        } else if (template.front && template.back) {
            this.selected.colorspec = '13abbda7-1d64-4f25-8bb2-c179b224825d' // 4/4
        } else if (template.front) {
            this.selected.colorspec = '32d3c223-f82c-492b-b915-ba065a00862f' // 4/0
        }

        if (this.$store.state.template.eddm_only) {
            this.axios.get('/eddm/dates')
            .then((response) => {
                this.eddm_dates = response.data.dates
                this.eddm_token = response.data.token
            })
            .catch((err) => {
                console.log(err)
            })
        }
        // this.confirmFiles()
    },
    mounted () {
        // Check if we have pending files (processing)
        this.checkImages()

        // Eddm.init({
        //     product: selectedProds[0].uuid,
        //     runsize: $('select[name=runsize] option:selected').attr('data-runsize'),
        // Eddm.init()

        //     target_before: '.set:first'
        // })
        // Eddm.buildMap()
        // var eddm = new Eddm()
        FileFlip.init()

        // http://localhost:8080/?user=primo&token=qU39F6uHYvaDoR7C6Z7pe2tAr2iHTh3w&mode=designer&template=2748c1f0-1d83-11e8-9cd4-e9ea3c4ce806

        $('select[name=ship_to], select[name=blind]').on('change', function () {
            $(this).next('p').html($(this).children('option:selected').attr('data-partial'))
        })

        $('.order-options .btn-success').click(function () {
            $('.order-options .form-control').each(function () {
                if ($(this).val() === '-1') {
                    $(this).addClass('optionError')
                }
            })
        })

        $(document).on('change', 'select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]', function () {
            let service = $(this).val()
            if (service !== '' && service !== '3e5e9bdd-d78a-4c28-a41d-fe1407925ca6' && service !== '934e270e-9523-48b9-93c7-78b0896e16a6') {
                $('option[data-name="100"]').addClass('hide')
            } else {
                $('option[data-name="100"]').removeClass('hide')
            }
        })

        // $('.order-options .form-control').on('change', function () {
        //     let total = $('.order-options .form-control').length
        //     let totalval = 0
        //     $('.order-options .form-control').each(function () {
        //         if ($(this).val() !== '-1') {
        //             totalval = totalval + 1
        //         }
        //     })
        //     if (total === totalval) {
        //         $('.order-options .btn-success').removeClass('disabled')
        //     } else {
        //         $('.order-options .btn-success').addClass('disabled')
        //     }
        //     if ($(this).hasClass('optionError') && $(this).val() !== '-1') {
        //         $(this).removeClass('optionError')
        //     }
        // })

        this.setHeight()
    },
    beforeDestroy () {
        this.watcher()
    },
    computed: {
        url () {
            let url = this.$store.state.pageUrl
            let queryString = '?'
            if (this.$route.params.uuid) {
                queryString += 'category=' + this.$route.params.uuid
            }
            if (this.$route.params.subcat) {
                if (queryString !== '?') {
                    queryString += '&'
                }
                queryString += 'subcategory=' + this.$route.params.subcat
            }
            if (queryString === '?') {
                queryString = ''
            }
            return url + queryString
        }
    },
    methods: {
        setPreview (file) {
            this.$refs.preview.setPreview(file)
        },
        stillProcessing () {
            Helpers.blackPop('Processing', 'Oops! Looks like we\'re still processing your files. Sometimes this can take up to several minutes, thank you for your patience!')
        },
        checkImages () {
            Object.keys(this.$store.state.template.files).forEach((key, index) => {
                if (this.$store.state.template.files[key].preview.includes('base64')) {
                    this.imagesProcessing.push(key)
                } else {
                    let index = this.imagesProcessing.indexOf(key)
                    if (index !== -1) {
                        this.imagesProcessing.splice(index, 1)
                    }
                }
            })
        },
        /*
         * Loop files and make sure all objects are confirmed
         * If any are unconfirmed push back the the designer
         */
        confirmFiles () {
            let template = this.$store.state.template
            let files = template.files
            Object.keys(files).forEach((key) => {
                let objects = files[key].json.objects
                for (let i in objects) {
                    if (objects[i].custom.editable === true && objects[i].custom.confirmed === false) {
                        files[key].confirmed = false
                        template.files = files
                        this.$store.commit('template', template)
                        this.$router.push({ name: 'Template Designer' })
                        Helpers.errorPop('Error', 'Please confirm all fields before continuing')
                    }
                }
            })
        },

        updateSelected (data) {
            this.selected = data
        },

        saveEddmData (data) {
            this.eddmData = data.data
            this.showFullService = false

            this.selected.runsize = this.eddmData.product_data.runsize_uuid
            this.selected.date = this.eddmData.delivery_date
            this.selected.colorspec = this.eddmData.product_data.colorspec_uuid
            this.selected.options = this.eddmData.product_data.options_uuids
            this.selected.product_cost = this.eddmData.product_price

            this.nextAccordion()
        },

        calculateCost (type = 'all') {
            let total = 0
            let productType = ''
            let skipDirectMailCharge = ['3e5e9bdd-d78a-4c28-a41d-fe1407925ca6', '934e270e-9523-48b9-93c7-78b0896e16a6']

            // Check for direct mail option on page
            if ($('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').length > 0 && $('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').val() !== '') {
                let service = $('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').val()
                // If direct mail is selected and not one of the options to skip it
                if (service !== '' && !skipDirectMailCharge.includes(service)) {
                    $('.prod-shipping').removeClass('panel-3').addClass('hide panel-skip')
                    $('.prod-summary').removeClass('panel-4').addClass('panel-3')
                    $('.panel-1 .btn-success').html('Continue to Summary')
                    $('span.shipping-type').html('Direct Mail Fee:')
                    productType = 'directmail'
                } else {
                    $('.prod-shipping').removeClass('hide panel-skip').addClass('panel-3')
                    $('.prod-summary').removeClass('panel-3').addClass('panel-4')
                    $('span.shipping-type').html('Shipping:')
                }
            }

            if ((type === 'shipping' || type === 'all')) {
                if (this.selected.turnaround && this.selected.turnaround.price) {
                    total += parseFloat(this.selected.turnaround.price)
                }
                if (this.selected.method && this.selected.method.service_price && !this.selected.method.group_with_cart) {
                    total += parseFloat(this.selected.method.service_price)
                }
                if (this.eddmData && this.eddmData.postage_price) {
                    total += parseFloat(this.eddmData.postage_price)
                }
            }

            if (type === 'shipping' && this.dm_fee > 0) {
                total += this.dm_fee
            }

            if (type === 'eddm_service' || type === 'all') {
                if (this.eddmData && this.eddmData.eddm_service_price) {
                    total += parseFloat(this.eddmData.eddm_service_price)
                }
            }

            if (type === 'product' || type === 'all') {
                if (this.selected.product_cost) {
                    total += parseFloat(this.selected.product_cost)
                }
            }

            if (type === 'all') {
                if (productType === 'directmail') {
                    let ms = 0
                    let option = $('select[name="87e09691-ef33-4cf4-8f17-48af06ce84f4"]').val()
                    let quantity = $('option[value="' + option + '"]').data('name')
                    if (parseFloat(quantity) === 250) {
                        ms = 50
                    } else if (parseFloat(quantity) === 500) {
                        ms = 75
                    } else if (parseFloat(quantity) === 1000) {
                        ms = 100
                    } else if (parseFloat(quantity) === 2500) {
                        ms = 125
                    } else if (parseFloat(quantity) === 5000) {
                        ms = 150
                    } else if (parseFloat(quantity) === 7500) {
                        ms = 240
                    } else if (parseFloat(quantity) === 10000) {
                        ms = 250
                    } else if (parseFloat(quantity) === 15000) {
                        ms = 400
                    } else if (parseFloat(quantity) === 20000) {
                        ms = 500
                    } else if (parseFloat(quantity) === 25000) {
                        ms = 550
                    } else if (parseFloat(quantity) === 30000) {
                        ms = 650
                    } else if (parseFloat(quantity) === 35000) {
                        ms = 700
                    } else if (parseFloat(quantity) === 40000) {
                        ms = 800
                    } else if (parseFloat(quantity) === 45000) {
                        ms = 850
                    } else if (parseFloat(quantity) === 50000) {
                        ms = 900
                    } else if (parseFloat(quantity) === 55000) {
                        ms = 950
                    } else if (parseFloat(quantity) === 60000) {
                        ms = 1000
                    } else if (parseFloat(quantity) === 65000) {
                        ms = 1050
                    } else if (parseFloat(quantity) === 70000) {
                        ms = 1100
                    } else if (parseFloat(quantity) === 75000) {
                        ms = 1150
                    } else if (parseFloat(quantity) === 80000) {
                        ms = 1200
                    } else if (parseFloat(quantity) === 85000) {
                        ms = 1250
                    } else if (parseFloat(quantity) === 90000) {
                        ms = 1300
                    } else if (parseFloat(quantity) === 95000) {
                        ms = 1350
                    } else if (parseFloat(quantity) === 100000) {
                        ms = 1400
                    }

                    /* add mailing service cost */
                    let service = $('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').val() // mailing_service
                    if (this.products.length && this.products[0].option_groups !== undefined) {
                        let ogMailingService = this.products[0].option_groups.data.filter(og => og.uuid === '05d933cb-0474-4e5a-bece-42504c6860fd')
                        if (ogMailingService.length) {
                            ogMailingService = ogMailingService[0]
                            if (ogMailingService.options !== undefined && ogMailingService.options.data !== undefined) {
                                let msSelected = ogMailingService.options.data.find(item => item.uuid === service)
                                let option = $('select[name="87e09691-ef33-4cf4-8f17-48af06ce84f4"]').val() // quantity
                                let quantity = $('option[value="' + option + '"]').data('name')
                                let optionprice = msSelected && msSelected.pricing !== undefined && msSelected.pricing.data !== undefined ? msSelected.pricing.data.filter(item => parseInt(item.startqty) === quantity && parseInt(item.endqty) === quantity) : []
                                if (optionprice.length) {
                                    optionprice = optionprice[0]
                                    ms += optionprice.price !== undefined ? optionprice.price : 0
                                }
                            }
                        }
                    }

                    this.dm_fee = ms
                    total += ms
                } else {
                    this.dm_fee = 0
                }
            }

            return total.toFixed(2)
        },

        nextAccordion () {
            if ($('.panel.active').hasClass('panel-1')) {
                $('.panel.active').removeClass('active')
                $('.panel-2').addClass('active')
                $('.panel-2 div h4 a').trigger('click')
            } else if ($('.panel.active').hasClass('panel-2')) {
                if (!this.$store.state.template.eddm_only) {
                    if (this.selected.turnaround === null) {
                        let comp = this.$refs.shipping
                        comp.fetchTurnaround()
                    }
                    $('.panel.active').removeClass('active')
                    $('.panel-3').addClass('active')
                    $('.panel-3 div h4 a').trigger('click')

                    $('.job_name').focus().select()
                    $('.o_turnaround').removeAttr('disabled')
                } else if (this.eddmData === null) {
                    this.showFullService = true
                } else {
                    $('.panel.active').removeClass('active')
                    $('.panel-4').addClass('active')
                    $('.panel-4 div h4 a').trigger('click')
                }
            } else if ($('.panel.active').hasClass('panel-3')) {
                $('.panel.active').removeClass('active')
                $('.panel-4').addClass('active')
                $('.panel-4 div h4 a').trigger('click')
            }

            this.setHeight()
        },

        setHeight () {
            this.windowMsgTemplateResize($('.templateDesigner').height(), $('.templateDesigner').width())
            setTimeout(() => {
                this.windowMsgTemplateResize($('.templateDesigner').height(), $('.templateDesigner').width())
            }, 1000)
        },

        setActivePanel (target, $event) {
            if (target === '.panel-1' && !$(target).hasClass('active')) {
                this.selected.turnaround = null
                this.selected.method = null
                $('.panel.active').removeClass('active')
                $(target).addClass('active')
                $(target + ' div h4 a').trigger('click')
            } else if (target === '.panel-2' && !$(target).hasClass('active')) {
                if (!this.selected.product || !this.selected.product_cost || !this.selected.runsize || !this.selected.runsizeDescription) {
                    if (!$('.panel-1').hasClass('active')) {
                        $('.panel.active').removeClass('active')
                        $('.panel-1').addClass('active')
                        $('.panel-1 div h4 a').trigger('click')
                    }
                } else {
                    if (this.selected.turnaround === null) {
                        let comp = this.$refs.shipping
                        comp.fetchTurnaround()
                    }
                    $('.panel.active').removeClass('active')
                    $(target).addClass('active')
                    $(target + ' div h4 a').trigger('click')
                }
            } else if (target === '.panel-3' && !$(target).hasClass('active')) {
                if (!this.selected.product || !this.selected.product_cost || !this.selected.runsize) {
                    if (!$('.panel-1').hasClass('active')) {
                        $('.panel.active').removeClass('active')
                        $('.panel-1').addClass('active')
                        $('.panel-1 div h4 a').trigger('click')
                    }
                } else if (!this.$store.state.template.eddm_only && (!this.selected.name || !this.selected.turnaround || !this.selected.shipping || !this.selected.method)) {
                    if (!$('.panel-2').hasClass('active')) {
                        if (this.selected.turnaround === null) {
                            let comp = this.$refs.shipping
                            comp.fetchTurnaround()
                        }
                        $('.panel.active').removeClass('active')
                        $('.panel-2').addClass('active')
                        $('.panel-2 div h4 a').trigger('click')
                    }
                } else {
                    $('.panel.active').removeClass('active')
                    $(target).addClass('active')
                    $(target + ' div h4 a').trigger('click')
                }
            }
            this.setHeight()
        },

        downloadFiles () {
            this.windowMsgDownloadFiles('https://interface.primoprint.com/v1/files/download/' + btoa(this.$store.state.savedTemplate.id + '|' + this.$auth.user().id))
        },

        addToCart () {
            if (this.cartButtonText === 'Add to Cart') {
                this.cartButtonText = 'Processing, please wait..'
                let shipping = this.$refs.shipping

                let data = {
                    template: this.$store.state.savedTemplate.id,
                    u: 1,
                    product: null,
                    runsize: this.selected.runsize,
                    colorspec: this.selected.colorspec,
                    groupship: 0,
                    sets: 1,
                    options: this.selected.options,
                    subtotal: parseFloat(this.calculateCost('product')),
                    design_cost: 0,
                    cat_id: 1,
                    sub_id: 1,
                    setlist: null,
                    files: {},
                    vendor_id: getCurrentVendorID(this.$auth.user(), this.url)
                }

                // EDDM Product
                if (this.$store.state.template.eddm_only) {
                    data.product = this.eddmData.product_data.product_uuid
                    data.setlist = [{
                        name: this.selected.name,
                        ship_to: 0,
                        method: 'EDDM',
                        method_id_eddm: this.eddmData.postage_price,
                        est_delivery: this.selected.date,
                        facility: 'Unknown',
                        set: 0,
                        files: {},
                        blind: 0,
                        eddm: this.eddmData
                    }]
                // Skip Shipping
                } else if ($('.panel-skip').length > 0) {
                    data.product = this.selected.product.id
                    data.setlist = [{
                        name: this.selected.name,
                        ship_to: 0,
                        method: 'Direct Mail',
                        method_id: 'eyJpdiI6ImRoXC9kMThpQ0t4OHc4NzRiOHd2V1VRPT0iLCJ2YWx1ZSI6InN1T1pCazRhOU9TSlp0SVFCSDRneGc9PSIsIm1hYyI6IjdlZDIxZGJiNzE3OTZhNmIzOTI3NWQ1YzQyZDFkYjA4NWY2OWNiZWM1YjI0ODY0NmI1MDU2MDkwYjZkY2ZmMDQifQ==',
                        method_id_direct_mail: parseFloat(this.calculateCost('shipping')),
                        facility: 'Unknown',
                        set: 0,
                        files: {},
                        blind: 0
                    }]
                // Standard Product
                } else {
                    data.product = this.selected.product.id
                    data.setlist = [{
                        name: this.selected.name,
                        turnaround: this.selected.turnaround.uuid,
                        turnaround_est: parseFloat(this.selected.turnaround.price),
                        est_production: this.selected.method.production,
                        ship_to: this.selected.shipping.id,
                        method: this.selected.method.service_code,
                        method_id: this.selected.method.service_id,
                        est_delivery: this.selected.method.delivery,
                        facility: this.selected.method.facility,
                        set: 0,
                        files: {},
                        blind: this.selected.blind,
                        shipping_options: shipping.getShippingOptions()
                    }]
                }

                this.axios.post('/cart/create', data)
                .then((res) => {
                    this.windowMsgLockWindow(false)
                    setTimeout(() => {
                        if (!window.location.href.includes('localhost')) {
                            window.parent.location.href = 'https://www.primoprint.com/cart'
                        } else {
                            window.parent.location.href = 'http://primoprint.test/cart'
                        }
                    }, 250)
                })
                .catch((err) => {
                    Helpers.errorPop('Error', err)
                })
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .optionError {border: 1px solid #c30000;}
    .panel-heading h4 {overflow: hidden;}

    @-webkit-keyframes spin {
        0%  {-webkit-transform: rotate(0deg);}
        100% {-webkit-transform: rotate(360deg);}
    }

    span.icon-loading1 {
        left: 0;
        color: #bbbbbb;
        font-size: 1.2em;
        padding: .1em;
        position: relative;
        float: left;
        left: -5px;
        -webkit-animation: spin .7s infinite linear;
    }

    .panel-title span.icon-loading1 {
        color: #3D773E;
        left: -1px;
        margin-right: 7px;
    }
    .panel-title a span {
        font-weight: 600;
        &:first-child {
            margin-right: 6px;
        }
    }
</style>



// WEBPACK FOOTER //
// TemplateOptions.vue?24ef647e